import styled from "@emotion/styled";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";

const FolderContainer = styled.div`
  position: relative;
  padding-left: 20px;
  margin-left: 3px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 1px;
    border-left: 1px dotted lightgray;
  }
`;

const FolderHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 3px;

  &:before {
    content: "";
    position: absolute;
    left: -20px;
    top: 50%;
    width: 20px;
    border-top: 1px dotted lightgray;
  }
`;

const FolderName = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  border: 1px solid #f3f3f3;
  border-radius: 4px;
  margin-right: 5px;
  height: 30px;
`;

const FolderIcon = styled.span`
  margin: 2px 0px 0px 5px;
  cursor: pointer;
  font-size: 20px;
  text-align: center;
`;

const FolderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const ValueSpanP = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  cursor: pointer;
  margin: 0px 5px 0px 5px;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background-color: #f3f3f3;
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 13px;
  cursor: pointer;
  margin: 3px 0px 0px 0px;
  background-color: #f3f3f3;
`;

const SC = {
  FolderContainer,
  FolderHeader,
  FolderName,
  FolderIcon,
  FolderActions,
  ValueSpanP,
  PopoverContainer,
  PopoverSpan,
  MoreVertIcon,
};

export default SC;
